import { assign } from 'lodash';

// defalt animation settings
const DEFAULT_SETTINGS = {
	gap: 0.3, // 200ms
};

// stagger children animation
export const staggerChildren = _settings => {
	const settings = assign( {}, DEFAULT_SETTINGS, _settings );

	// variants
	const variants = {
		initial: {
			opacity: 0,
		},
		enter: {
			opacity: 1,
			transition: {
				ease: 'anticipate',
				duration: 0.1,
				staggerChildren: settings.gap,
			}
		}
	};

	return {
		variants,
		initial: 'initial',
        animate: 'enter',
	};
};

